/** @format */

const NavbarTranslations = {
  en: {
    'Navbar.link.about': 'About WeMi',
    'Navbar.link.services': 'WeMi Services',
    'Navbar.link.spaces': 'WeMi Spaces',
    'Navbar.link.families': 'Milan Families',
    'Navbar.link.login': 'Login',
    'Navbar.button.logout': 'Logout',

    'Navbar.link.about.dropdown1': 'Home care services',
    'Navbar.link.about.dropdown2': 'For us Citizens',
    'Navbar.link.about.dropdown3': 'For us community',
    'Navbar.link.about.dropdown4': 'For us operators',
    'Navbar.link.about.dropdown5': 'Advantages',
    'Navbar.link.about.dropdown6': 'How to access',

    'Navbar.link.services.dropdown1': 'Nurses',
    'Navbar.link.services.dropdown2': 'Health',
    'Navbar.link.services.dropdown3': 'Family support',
    'Navbar.link.services.dropdown4': 'Social sharing',

    'Navbar.link.userMenu.item1': 'Citizen personal area',
    'Navbar.link.userMenu.item2': 'Worker personal area',
    'Navbar.link.userMenu.item3': 'Ent personal area',
  },
  it: {
    'Navbar.link.about': 'Chi siamo',
    'Navbar.link.services': 'Servizi WeMi',
    'Navbar.link.spaces': 'Spazi WeMi',
    'Navbar.link.families': 'Milano Famiglie',
    'Navbar.link.login': 'Accedi',
    'Navbar.button.logout': 'Esci',

    'Navbar.link.about.dropdown1': 'Servizi domiciliari',
    'Navbar.link.about.dropdown2': 'Per noi cittadini',
    'Navbar.link.about.dropdown3': 'Per noi comunità',
    'Navbar.link.about.dropdown4': 'Per noi operatori',
    'Navbar.link.about.dropdown5': 'Quali vantaggi',
    'Navbar.link.about.dropdown6': 'Come accedere',

    'Navbar.link.services.dropdown1': 'Tate colf badanti',
    'Navbar.link.services.dropdown2': 'Benessere della persona',
    'Navbar.link.services.dropdown3': 'Sostegno alle famiglie',
    'Navbar.link.services.dropdown4': 'Condivisione sociale',

    'Navbar.link.userMenu.item1': 'Area personale cittadino',
    'Navbar.link.userMenu.item2': 'Area personale lavoratore',
    'Navbar.link.userMenu.item3': 'Area personale ente',
  },
};

export default NavbarTranslations;
